"use client";

import { routes } from "../../../../config/routes";
import AvatarCard from "@core/ui/avatar-card";
import DateCell from "@core/ui/date-cell";
import { createColumnHelper } from "@tanstack/react-table";
import { Text, Flex } from "rizzui";
// import TableRowActionGroup from "../../table-row-action-group";
import { Campaign } from "packages/app/src/types";
import { MoreActions } from "../../../../components/table-utils/campaign-more-actions";
import { suspendCampaign } from "../../../api/suspend-campaign";

function formatCurrency(amount: number, code: string) {
  try {
    return new Intl.NumberFormat(undefined, {
      style: "currency",
      currency: code,
      minimumFractionDigits: 2,
    }).format(amount);
  } catch {
    return `${amount.toLocaleString(undefined, {
      minimumFractionDigits: 2,
    })} ${code}`;
  }
}

const columnHelper = createColumnHelper<Campaign>();

export const campaignListColumns = [
  // columnHelper.display({
  //   id: "actions",
  //   header: "Actions",
  //   size: 80,
  //   cell: ({ row, table: { options } }) => (
  //     <TableRowActionGroup
  //       viewUrl={routes.campaignManagement.details(row.original._id)}
  //       onDelete={() => options.meta?.handleDeleteRow?.(row.original)}
  //     />
  //   ),
  // }),
  columnHelper.accessor("campaignId", {
    header: "Campaign ID",
    size: 200,
    cell: (info) => (
      <Text className="text-sm font-medium">{info.getValue()}</Text>
    ),
  }),

  columnHelper.accessor("title", {
    header: "Title",
    size: 350,
    enableSorting: true,
    cell: (info) => info.getValue(),
  }),
  columnHelper.accessor("explanation", {
    header: "Explanation",
    size: 600,
    enableSorting: true,
    cell: (info) => info.getValue(),
  }),

 
  columnHelper.accessor("createdAt", {
    header: "Created On",
    size: 200,
    cell: (info) => <DateCell date={new Date(info.getValue())} />,
  }),

];